import { useState } from "react";
import { api, ApiHatasi, mb, sayi, tarih } from "../api";
import { Bildirim, Durum, DurumRozeti, HataKutusu, Kart, Rozet, Tablo, useCek } from "../ui";
import { YeniAlanAdi } from "./AlanAdi";

// --------------------------------------------------------------- alan adlari

export function AlanAdlari({ git, rol }: { git: (y: string) => void; rol: "operator" | "musteri" | "kutu" }) {
  const operator = rol === "operator";
  const liste = useCek(() => api.alanadlari(), []);
  const kutular = useCek(() => api.kutular(), []);
  const musteriler = useCek(() => (operator ? api.musteriler() : Promise.resolve({ veri: [] })), []);
  const [yeni, setYeni] = useState(false);

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Alan adları</h1>
          <p>
            Bir alan adı, zorunlu DNS kayıtları tamamlanana kadar gönderime kapalıdır. Bu kural
            sunucudaki bütün müşterilerin itibarını korur.
          </p>
        </div>
        <div className="eylemler">
          {operator && (
            <button className="dugme ana" onClick={() => setYeni((v) => !v)}>
              {yeni ? "Vazgeç" : "Yeni alan adı"}
            </button>
          )}
        </div>
      </div>

      {yeni && (
        <div style={{ marginBottom: 18 }}>
          <YeniAlanAdi
            musteriler={musteriler.veri?.veri ?? []}
            vazgec={() => setYeni(false)}
            bitti={(id) => {
              setYeni(false);
              liste.yenile();
              git("/alanadlari/" + id);
            }}
          />
        </div>
      )}

      <Kart baslik={`Alan adları (${liste.veri?.adet ?? 0})`}>
        <Durum cekim={liste}>
          {(l) =>
            l.veri.length === 0 ? (
              <div className="bos">Alan adı yok</div>
            ) : (
              <Tablo basliklar={operator
                  ? ["Alan adı", "Açıklama", "Kiracı", "#Kutu", "Eklendi", ""]
                  : ["Alan adı", "Açıklama", "#Kutu", "Eklendi", ""]}>
                {l.veri.map((a) => (
                  <tr key={a.id}>
                    <td>
                      <strong>{a.name}</strong>
                    </td>
                    <td style={{ color: "var(--n-600)" }}>{a.description ?? "—"}</td>
                    {operator && (
                      <td className="tek">{a.memberTenantId ?? <Rozet tur="uyari">kiracısız</Rozet>}</td>
                    )}
                    <td className="sayi">
                      {(kutular.veri?.veri ?? []).filter((k) => k.domainId === a.id).length}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>{tarih(a.createdAt)}</td>
                    <td>
                      <button className="dugme kucuk" onClick={() => git("/alanadlari/" + a.id)}>
                        DNS
                      </button>
                    </td>
                  </tr>
                ))}
              </Tablo>
            )
          }
        </Durum>
      </Kart>
    </>
  );
}

// --------------------------------------------------------------- limitler


/**
 * DISK KOTASI
 *
 * Stalwart Community'de kutu basina disk kotasi sunucuya ZORLATILAMIYOR.
 * Panel olcer, esikte uyarir ve kota dolmussa yeni kutu actirmaz; gelen
 * postayi ASLA reddetmez — kotayi asmak, posta kaybetmekten iyidir.
 */
function KotaKarti() {
  const cekim = useCek(() => api.kotaDurum(), []);
  const [bekliyor, setBekliyor] = useState(false);
  const [mesaj, setMesaj] = useState<string | null>(null);

  return (
    <Kart
      baslik="Disk kotası"
      eylem={
        <button
          className="dugme kucuk"
          disabled={bekliyor}
          onClick={async () => {
            setBekliyor(true);
            try {
              const y = await api.kotaDenetle();
              setMesaj(
                `${y.veri.incelenen} müşteri incelendi. ${y.veri.uyarilan.length} uyarı, ` +
                  `${y.veri.alarmVerilen.length} alarm, ${y.veri.bildirilen} bildirim gönderildi.`,
              );
              cekim.yenile();
            } catch (e: any) {
              setMesaj(e?.message ?? "Denetlenemedi");
            } finally {
              setBekliyor(false);
            }
          }}
        >
          {bekliyor ? "…" : "şimdi denetle"}
        </button>
      }
    >
      {mesaj && <Bildirim tur="iyi">{mesaj}</Bildirim>}
      <Durum cekim={cekim}>
        {(y) => (
          <>
            <Tablo basliklar={["Müşteri", "Paket", "#Kullanılan", "#Limit", "Doluluk", "En büyük kutu"]}>
              {y.veri.map((k) => (
                <tr key={k.kiraciId}>
                  <td>{k.ad}</td>
                  <td>
                    <Rozet tur="marka">{k.paket}</Rozet>
                  </td>
                  <td className="sayi">{mb(k.disk.kullanilanBayt)}</td>
                  <td className="sayi">{k.disk.limitMb ? k.disk.limitMb + " MB" : "∞"}</td>
                  <td>
                    <div className={"cubuk" + (k.asilanEsik >= 100 ? " dolu" : k.asilanEsik >= 80 ? " orta" : "")}>
                      <i style={{ width: Math.min(100, Math.max(2, k.disk.oran * 100)) + "%" }} />
                    </div>
                    <small>
                      %{Math.round(k.disk.oran * 100)}
                      {k.asilanEsik >= 100 && " — dolu"}
                    </small>
                  </td>
                  <td>
                    {k.enBuyukKutular[0] ? (
                      <small>
                        {k.enBuyukKutular[0].eposta}
                        <br />
                        {mb(k.enBuyukKutular[0].bayt)}
                      </small>
                    ) : (
                      <small>—</small>
                    )}
                  </td>
                </tr>
              ))}
            </Tablo>
            <small style={{ display: "block", marginTop: 10 }}>{y.not}</small>
          </>
        )}
      </Durum>
    </Kart>
  );
}

export function Limitler() {
  const kilitli = useCek(() => api.kilitliler(), []);
  const musteriler = useCek(() => api.musteriler(), []);
  const [rapor, setRapor] = useState<string | null>(null);
  const [hata, setHata] = useState<ApiHatasi | null>(null);
  const [bekliyor, setBekliyor] = useState(false);

  async function denetle() {
    setHata(null);
    setRapor(null);
    setBekliyor(true);
    try {
      const y = await api.limitDenetle();
      const degisen = y.veri.filter((r) => r.kilitlenen.length || r.acilan.length || r.hata.length);
      setRapor(
        degisen.length === 0
          ? "Denetim tamam: değişiklik gerekmedi."
          : degisen
              .map(
                (r) =>
                  `${r.ad}: ${r.kullanilan}/${r.limit} alıcı — ${r.kilitlenen.length} kilitlendi, ` +
                  `${r.acilan.length} açıldı${r.hata.length ? `, ${r.hata.length} hata` : ""}`,
              )
              .join(" · "),
      );
      kilitli.yenile();
    } catch (h) {
      setHata(h instanceof ApiHatasi ? h : new ApiHatasi(String(h), "bilinmiyor", 0));
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <>
      
      <KotaKarti />
<div className="baslik">
        <div>
          <h1>Limitler ve gönderim kilidi</h1>
          <p>
            Günlük gönderim hakkı dolan kutular kilitlenir. Kilit <strong>geri alınabilir</strong>,
            parolaya dokunmaz ve kutu kilitliyken <strong>gelen posta kabul edilmeye devam eder</strong>.
            Hak ertesi gün yenilendiğinde kilit kendiliğinden açılır.
          </p>
        </div>
        <div className="eylemler">
          <button className="dugme ana" onClick={denetle} disabled={bekliyor}>
            {bekliyor ? "Denetleniyor…" : "Şimdi denetle"}
          </button>
        </div>
      </div>

      {hata && <HataKutusu hata={hata} />}
      {rapor && <Bildirim tur="iyi">{rapor}</Bildirim>}

      <Bildirim tur="uyari">
        <strong>Dürüst uyarı:</strong> Kilit yalnızca gönderimi değil, kutuya girişi de (IMAP dahil)
        kapatır. Stalwart Community sürümünde gönderimi tek başına durduran bir ayar yok — denendi ve
        çalışmadığı görüldü. Bu yüzden kilit ancak günlük hak <em>tamamen</em> dolduğunda uygulanıyor.
      </Bildirim>

      <div className="izgara d2">
        <Kart baslik={`Şu an kilitli (${kilitli.veri?.veri.length ?? 0})`}>
          <Durum cekim={kilitli}>
            {(k) =>
              k.veri.length === 0 ? (
                <div className="bos">Kilitli kutu yok</div>
              ) : (
                <Tablo basliklar={["Adres", "Kiracı", "Durum", "Sebep"]}>
                  {k.veri.map((x) => (
                    <tr key={x.hesapId}>
                      <td>
                        <strong>{x.eposta}</strong>
                      </td>
                      <td className="tek">{x.kiraci}</td>
                      <td>
                        <DurumRozeti durum={x.panelDurum} />
                      </td>
                      <td style={{ color: "var(--n-600)" }}>{x.sebep ?? "—"}</td>
                    </tr>
                  ))}
                </Tablo>
              )
            }
          </Durum>
        </Kart>

        <Kart baslik="Müşteri limitleri">
          <Durum cekim={musteriler}>
            {(m) =>
              m.veri.length === 0 ? (
                <div className="bos">Müşteri yok</div>
              ) : (
                <Tablo basliklar={["Müşteri", "Paket", "Durum"]}>
                  {m.veri.map((x) => (
                    <tr key={x.id}>
                      <td>{x.ad}</td>
                      <td>
                        <Rozet tur="marka">{x.paket}</Rozet>
                      </td>
                      <td>
                        <DurumRozeti durum={x.durum} />
                      </td>
                    </tr>
                  ))}
                </Tablo>
              )
            }
          </Durum>
        </Kart>
      </div>
    </>
  );
}

// --------------------------------------------------------------- alarmlar

export function Alarmlar() {
  const liste = useCek(() => api.alarmlar(), []);
  return (
    <>
      <div className="baslik">
        <div>
          <h1>Alarmlar</h1>
          <p>
            <strong>izolasyon_ihlali</strong> türü, bir kiracının başka bir kiracının kaydına
            erişmeye çalıştığını gösterir. Geçit kaydı engeller ama bu alarm asla görmezden
            gelinmemelidir.
          </p>
        </div>
      </div>
      <Kart>
        <Durum cekim={liste}>
          {(l) =>
            l.veri.length === 0 ? (
              <div className="bos">Açık alarm yok</div>
            ) : (
              <Tablo basliklar={["Tür", "Kullanıcı", "Kiracı", "Ayrıntı", "Zaman"]}>
                {l.veri.map((a) => (
                  <tr key={a.id}>
                    <td>
                      <Rozet tur={a.tur === "izolasyon_ihlali" ? "kotu" : "uyari"}>{a.tur}</Rozet>
                    </td>
                    <td>{a.kullanici ?? "—"}</td>
                    <td className="tek">{a.kiraci_id ?? "—"}</td>
                    <td className="tek" style={{ maxWidth: 380, overflow: "hidden", textOverflow: "ellipsis" }}>
                      {a.ayrinti ?? "—"}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>{tarih(a.zaman)}</td>
                  </tr>
                ))}
              </Tablo>
            )
          }
        </Durum>
      </Kart>
    </>
  );
}

// --------------------------------------------------------------- denetim

export function Denetim() {
  const liste = useCek(() => api.denetim(), []);
  const yarida = useCek(() => api.yaridaKalanlar(), []);

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Denetim kaydı</h1>
          <p>
            Her işlem <strong>başlamadan önce</strong> yazılır, bittiğinde güncellenir. Panel çökerse
            Stalwart'ta oluşmuş ama panelde tamamlanmamış kayıtlar "yarıda kalan" olarak görünür.
          </p>
        </div>
      </div>

      {(yarida.veri?.veri.length ?? 0) > 0 && (
        <div style={{ marginBottom: 18 }}>
          <Kart baslik={`Yarıda kalanlar (${yarida.veri?.veri.length})`}>
            <Tablo basliklar={["İşlem", "Kullanıcı", "Nesne", "Başlangıç"]}>
              {(yarida.veri?.veri ?? []).map((d) => (
                <tr key={d.id}>
                  <td>
                    <strong>{d.eylem}</strong>
                  </td>
                  <td>{d.kullanici}</td>
                  <td className="tek">
                    {d.nesne_tip ?? "—"} {d.nesne_id ?? ""}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }}>{tarih(d.baslangic)}</td>
                </tr>
              ))}
            </Tablo>
          </Kart>
        </div>
      )}

      <Kart baslik="Son işlemler">
        <Durum cekim={liste}>
          {(l) =>
            l.veri.length === 0 ? (
              <div className="bos">Kayıt yok</div>
            ) : (
              <Tablo basliklar={["İşlem", "Kullanıcı", "Rol", "Nesne", "Durum", "Zaman"]}>
                {l.veri.map((d) => (
                  <tr key={d.id}>
                    <td>
                      <strong>{d.eylem}</strong>
                      {d.hata && (
                        <div style={{ color: "var(--bad)", fontSize: 12 }}>{d.hata}</div>
                      )}
                    </td>
                    <td>{d.kullanici}</td>
                    <td>
                      <Rozet>{d.rol}</Rozet>
                    </td>
                    <td className="tek">
                      {d.nesne_tip ?? "—"} {d.nesne_id ?? ""}
                    </td>
                    <td>
                      {d.durum === "bitti" ? (
                        <Rozet tur="iyi">bitti</Rozet>
                      ) : d.durum === "hata" ? (
                        <Rozet tur="kotu">hata</Rozet>
                      ) : (
                        <Rozet tur="uyari">başladı</Rozet>
                      )}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>{tarih(d.baslangic)}</td>
                  </tr>
                ))}
              </Tablo>
            )
          }
        </Durum>
      </Kart>
    </>
  );
}

// --------------------------------------------------------------- kullanim

export function Kullanim() {
  const [gun, setGun] = useState(30);
  const liste = useCek(() => api.kullanim(gun), [gun]);

  return (
    <>
      <div className="baslik">
        <div>
          <h1>Kullanım</h1>
          <p>
            Veriler her 5 dakikada bir sunucu günlüğünden toplanır. Stalwart Community sürümünde
            ölçüm arayüzü kapalı olduğundan bu geçmiş <strong>geriye dönük üretilemez</strong>.
          </p>
        </div>
        <div className="eylemler">
          <select
            className="kucuk-girdi"
            value={gun}
            onChange={(e) => setGun(Number(e.target.value))}
            aria-label="Dönem"
          >
            <option value={7}>son 7 gün</option>
            <option value={30}>son 30 gün</option>
            <option value={90}>son 90 gün</option>
          </select>
        </div>
      </div>

      <Kart>
        <Durum cekim={liste}>
          {(l) =>
            l.veri.length === 0 ? (
              <div className="bos">Henüz veri toplanmadı</div>
            ) : (
              <Tablo basliklar={["Tarih", "Kiracı", "#Kutu", "#Disk", "#Giden alıcı", "#Gelen ileti"]}>
                {[...l.veri].reverse().map((s) => (
                  <tr key={s.tarih + s.kiraci_id}>
                    <td>{s.tarih}</td>
                    <td className="tek">{s.kiraci_id}</td>
                    <td className="sayi">{s.kutu_sayisi}</td>
                    <td className="sayi">{(s.disk_bayt / 1048576).toFixed(1)} MB</td>
                    <td className="sayi">{sayi(s.giden_alici)}</td>
                    <td className="sayi">{sayi(s.gelen_ileti)}</td>
                  </tr>
                ))}
              </Tablo>
            )
          }
        </Durum>
      </Kart>
    </>
  );
}
